import ContactStillNeedHelpComponent from "../../components/contact/ContactStillNeedHelpComponent.tsx";
import ContactPageLayout from "./ContactPageLayout.tsx";

export default function ContactInternetNotWorking() {
    return (
        <ContactPageLayout
            meta_title={"Det skal du gøre, når internettet ikke virker"}
            meta_description={"Vi anbefaler, at du starter med at tjekke efter for driftsforstyrrelser i dit område. Hvis der ikke er noget at se, sidder vi klar til at hjælpe dig."}
            title={"Mit internet virker slet ikke"}
            className={"page-contact-offline"}
            content={
                <>
                    <section className="contact-content">
                        <p>Det er vi kede af at høre!</p>
                        <p>Vi anbefaler, at du starter med at tjekke efter driftsforstyrrelser i dit område her:</p>
                        <a href={'https://drift.hiper.dk'} target={"_blank"} className={'button button--montserrat teal'}>Driftsstatus</a>
                    </section>

                    <ContactStillNeedHelpComponent phone={true}/>
                </>
            }
        />
    )
}
